'use client';

import Image from 'next/image';
import WindowSize from '@/utils/windowSize';

export default function DoubleImageText({ block, position }) {
  const {
    title,
    description_rte,
    image_right,
    image_left,
    background_color,
    text_color,
    _metadata
  } = block;

  const windowSize = WindowSize();

  return (
    <section
      id={_metadata.uid + '_' + position}
      data-name="editorial-double-image-text"
      className={`px-5 py-20 sm:px-15 lg:px-16 lg:py-[120px] xl:px-[120px] bg-[${background_color}]`}
    >
      <div className="max-w-container mx-auto min-h-[360px] sm:flex lg:min-h-[515px]">
        <div className="self-center text-center max-[639px]:mx-auto sm:mr-20 sm:text-left">
          {title && (
            <h2 className={`h4 sm:h3 lg:h2 mb-10 text-[${text_color}]`}>
              {title}
            </h2>
          )}
          {description_rte && (
            <div
              className={`body-r sm:body-l mb-15 sm:mb-0 [&_a]:underline [&_a]:hover:text-[#aa6147] text-[${text_color}]`}
              dangerouslySetInnerHTML={{ __html: description_rte }}
            />
          )}
        </div>
        {windowSize.width > 640 ? (
          <>
            <Image
              src={image_left.url}
              width="350"
              height="467"
              alt={image_left.title.replace(/\.[^/.]+$/, '')}
              sizes="(min-width: 1280px) 350px, (min-width: 1024px) 260px, (min-width: 640px) 156px, 152px"
              className="w- mr-5 mb-8 h-[222px] w-[152px] self-center sm:mb-12 sm:h-[209px] sm:w-[164px] lg:h-[347px] lg:w-[260px] xl:h-[467px] xl:w-[350px]"
            />
            <Image
              src={image_right.url}
              width="350"
              height="467"
              alt={image_right.title.replace(/\.[^/.]+$/, '')}
              sizes="(min-width: 1280px) 350px, (min-width: 1024px) 260px, (min-width: 640px) 156px, 152px"
              className="mt-4 h-[222px] w-[152px] self-center sm:mt-12 sm:h-[209px] sm:w-[164px] lg:h-[347px] lg:w-[260px] xl:h-[467px] xl:w-[350px]"
            />
          </>
        ) : (
          <div className="flex justify-center">
            <Image
              src={image_left.url}
              width="152"
              height="190"
              sizes="152px"
              alt={image_left.title.replace(/\.[^/.]+$/, '')}
              className="mr-5 mb-8 h-[190px] w-[152px]"
            />
            <Image
              src={image_right.url}
              width="152"
              height="190"
              sizes="152px"
              alt={image_right.title.replace(/\.[^/.]+$/, '')}
              className="mt-4 h-[190px] w-[152px]"
            />
          </div>
        )}
      </div>
    </section>
  );
}
